export default {
      id: "ic_circle-twitter-usage",
      viewBox: "0 0 85 85",
      url: "/" + "images/icons.3.109.2.svg#ic_circle-twitter-usage",
      toString: function () {
        return this.url;
      }
    }